import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { combineLatest, concat, Observable, of } from 'rxjs';
import { concatMap, concatMapTo, delay, finalize, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { SetupResolver } from './setup.resolver';
import { TokenResolver } from './token.resolver';
import { LoaderService } from './loader.service';

@Injectable({ providedIn: 'root' })
export class TokenSetupResolver implements Resolve<any> {
    constructor(
        private readonly tokenResolver: TokenResolver, 
        private readonly setupResolver: SetupResolver,
        private readonly loaderService: LoaderService
    ) {}

    resolve(): Observable<any> {
        
        this.loaderService.setAppLoading(true);
        
        return this.tokenResolver.resolve().pipe(
            concatMap((token) => this.setupResolver.resolve()),
            
            finalize(() => {
                this.loaderService.setAppLoading(false);
            })
        );
    }
}
